var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { Alert, Typography } from '@mui/material';
import Divider from '@mui/material/Divider';
import NewCard from '@Components/NewCard';
import Container from '@Components/Container';
import Grid from '@mui/material/Grid2';
import Button from '@Components/Button';
import LogoUploader from './components/Logo';
import ColorPicker from './components/Color';
import CardPreview from './components/CardPreview';
import { getPreferences, updatePreferences, uploadLogo } from '../../../../services/preferences';
import Loader from '@Components/Loader';
import { useUserMetadataField } from '../../../../hooks/useUserMetadataField';
export var AppSettings = function () {
    var _a = useState(false), loading = _a[0], setLoading = _a[1];
    var financialInstitutionId = useUserMetadataField('financialInstitutionId');
    var _b = useState(false), errorSettings = _b[0], setErrorSettings = _b[1];
    var _c = useState({
        institutionId: '',
        accountCardColor: '',
        accountCardTextColor: '',
        logo: '',
    }), settings = _c[0], setSettings = _c[1];
    useEffect(function () {
        var loadSettings = function () { return __awaiter(void 0, void 0, void 0, function () {
            var preferences, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, 3, 4]);
                        setLoading(true);
                        console.log('financialInstitutionId', financialInstitutionId);
                        return [4 /*yield*/, getPreferences(financialInstitutionId)];
                    case 1:
                        preferences = _a.sent();
                        console.log('preferences', preferences);
                        setSettings({
                            institutionId: preferences === null || preferences === void 0 ? void 0 : preferences.institutionId,
                            accountCardColor: preferences === null || preferences === void 0 ? void 0 : preferences.accountCardColor,
                            accountCardTextColor: preferences === null || preferences === void 0 ? void 0 : preferences.accountTextColor,
                            logo: preferences === null || preferences === void 0 ? void 0 : preferences.logo,
                        });
                        return [3 /*break*/, 4];
                    case 2:
                        error_1 = _a.sent();
                        setErrorSettings(error_1.message);
                        console.error("Error loading settings:", error_1);
                        return [3 /*break*/, 4];
                    case 3:
                        setLoading(false);
                        return [7 /*endfinally*/];
                    case 4: return [2 /*return*/];
                }
            });
        }); };
        loadSettings();
    }, []);
    var _d = useState(''), color = _d[0], setColor = _d[1];
    var _e = useState(''), textColor = _e[0], setTextColor = _e[1];
    // logoData has logoUrl string and logoFile FILE object
    var _f = useState({
        logoUrl: '',
        logoFile: null,
    }), logoData = _f[0], setLogoData = _f[1];
    var saveSettings = function () { return __awaiter(void 0, void 0, void 0, function () {
        var logoPath;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setLoading(true);
                    if (!logoData.logoFile) return [3 /*break*/, 2];
                    return [4 /*yield*/, uploadLogo(logoData.logoFile)];
                case 1:
                    logoPath = _a.sent();
                    _a.label = 2;
                case 2:
                    console.log('Guardando configuraciones:', { color: color, textColor: textColor, logoPath: logoPath });
                    return [4 /*yield*/, updatePreferences(financialInstitutionId, __assign({ account_card_color: color, account_text_color: textColor }, logoData.logoFile && { logo: logoPath }))];
                case 3:
                    _a.sent();
                    setLoading(false);
                    return [2 /*return*/];
            }
        });
    }); };
    useEffect(function () {
        setLogoData(function (prev) { return (__assign(__assign({}, prev), { logoUrl: settings.logo || '' })); });
    }, [settings.logo]);
    useEffect(function () {
        setColor(settings.accountCardColor);
    }, [settings.accountCardColor]);
    useEffect(function () {
        setTextColor(settings.accountCardTextColor);
    }, [settings.accountCardTextColor]);
    return (_jsxs("div", __assign({ style: { padding: '16px' } }, { children: [loading &&
                _jsx(Loader, {}), errorSettings && _jsx(Alert, __assign({ severity: "error" }, { children: errorSettings })), _jsx(Typography, __assign({ variant: "h5", component: "div", sx: { marginBottom: '8px' } }, { children: "Apariencia de la cuenta" })), _jsx(Divider, { sx: { marginBottom: '8px' } }), _jsxs(NewCard, { children: [_jsxs(Container, __assign({ direction: 'row' }, { children: [_jsx(CardPreview, { color: color, textColor: textColor, logo: logoData.logoUrl }), _jsxs(Grid, __assign({ container: true, spacing: 2, width: '100%' }, { children: [_jsx(Grid, __assign({ size: 12 }, { children: _jsx(LogoUploader, { logoData: logoData, setLogoData: setLogoData }) })), _jsx(Grid, __assign({ size: 12 }, { children: _jsx(ColorPicker, { color: color, setColor: setColor, legend: 'Este color ser\u00E1 el fondo de la tarjeta' }) })), _jsx(Grid, __assign({ size: 12 }, { children: _jsx(ColorPicker, { color: textColor, setColor: setTextColor, legend: 'Este color ser\u00E1 el color del texto de la tarjeta' }) }))] }))] })), _jsx(Container, __assign({ justifyContent: "flex-end", direction: "row" }, { children: _jsx(Button, __assign({ variant: "contained", color: "primary", onClick: saveSettings, disabled: loading }, { children: "Guardar" })) }))] })] })));
};
export default AppSettings;
